var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"topinput"},[_c('van-cell-group',[_c('van-field',{attrs:{"type":"textarea","label":"留言","placeholder":"请输入留言","rows":"2","autosize":"","maxlength":"50","show-word-limit":""},model:{value:(_vm.message2),callback:function ($$v) {_vm.message2=$$v},expression:"message2"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }